import {
  FormHelperText,
  TextField as MUITextField,
  Typography,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import { useAddress } from "components/request-document/components/Address";
import {
  StyleCheckbox,
  StyledTableCell,
  useStyles,
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function PersonalIncomeWFT({ formik }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });

  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const sourceIncoms = get(masterData, "sourcesOfincomeConfig", []);
  const typeOfIntellectualpropertyConfig = get(
    masterData,
    "typeOfIntellectualpropertyConfig",
    []
  );

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <Typography style={{ fontWeight: "bold" }}>
                Average personal income per year (Please select only one)
              </Typography>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.IncomeNolessWFTP"
                    checked={formik.values.document.IncomeNolessWFTP === "true"}
                    onClick={() => {
                      formik.setFieldValue(
                        "document.IncomeNolessWFTP",
                        formik.values.document.IncomeNolessWFTP === "true"
                          ? "false"
                          : "true"
                      );
                      formik.setFieldValue(
                        "document.IncomeMorethanWFTP",
                        "false"
                      );
                    }}
                  />
                }
                label={
                  <Typography style={{ fontWeight: "bold" }}>
                    {` Personal income no less than 80,000 USD/year in the past 2 years 
before applying for the visa `}
                  </Typography>
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {formik.values.document.IncomeNolessWFTP === "true" ? (
        <>
          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Year</InputLabel>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Income (USD)</InputLabel>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>
                    Total current year income (as of the submission date)
                  </InputLabel>
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    views={["year", "month", "date"]}
                    name={`document.NolessCurrentYearIncome`}
                    label="Start"
                    value={
                      get(
                        formik.values,
                        `document.NolessCurrentYearIncome`,
                        null
                      ) || null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.NolessCurrentYearIncome`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(`document.NolessCurrentYearIncome`, formik)}
                    helperText={getErrorMessage(
                      `document.NolessCurrentYearIncome`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="End"
                    views={["year", "month", "date"]}
                    name={`document.NolessCurrentYearIncomeEnd`}
                    value={
                      get(
                        formik.values,
                        `document.NolessCurrentYearIncomeEnd`,
                        null
                      ) || null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.NolessCurrentYearIncomeEnd`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(
                      `document.NolessCurrentYearIncomeEnd`,
                      formik
                    )}
                    helperText={getErrorMessage(
                      `document.NolessCurrentYearIncomeEnd`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>IncomeCurrentYearUSD</InputLabel>
                  <TextField
                    variant="outlined"
                    name="document.NolessIncomeCurrentYearUSD"
                    value={formik.values.document.NolessIncomeCurrentYearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Last year (YYYY)</InputLabel>
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="YYYY"
                    views={["year"]}
                    name={`document.NolessLastYear`}
                    value={
                      get(formik.values, `document.NolessLastYear`, null) ||
                      null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.NolessLastYear`,
                        date.format("YYYY")
                      );
                    }}
                    error={isError(`document.NolessLastYear`, formik)}
                    helperText={getErrorMessage(
                      `document.NolessLastYear`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>IncomeLastYearUSD</InputLabel>
                  <TextField
                    variant="outlined"
                    name="document.NolessIncomeLastYearUSD"
                    value={formik.values.document.NolessIncomeLastYearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Last 2nd year (YYYY)</InputLabel>
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="YYYY"
                    views={["year"]}
                    name={`document.NolessLast2Year`}
                    value={
                      get(formik.values, `document.NolessLast2Year`, null) ||
                      null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.NolessLast2Year`,
                        date.format("YYYY")
                      );
                    }}
                    error={isError(`document.NolessLast2Year`, formik)}
                    helperText={getErrorMessage(
                      `document.NolessLast2Year`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>IncomeLast2YearUSD</InputLabel>
                  <TextField
                    variant="outlined"
                    name="document.NolessIncomeLast2YearUSD"
                    value={formik.values.document.NolessIncomeLast2YearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={7}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Sources of income</InputLabel>
                  <FormGroup row>
                    {sourceIncoms.map((x) => (
                      <>
                        {x.sourcesOfincomeID !== "O" ? (
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.NolessWFTPsourcesOfincomeID"
                                checked={
                                  formik.values.document
                                    .NolessWFTPsourcesOfincomeID ===
                                  x.sourcesOfincomeID
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "document.NolessWFTPsourcesOfincomeID",
                                    x.sourcesOfincomeID
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                        ) : null}
                      </>
                    ))}
                  </FormGroup>
                  {sourceIncoms.map((x) => (
                    <>
                      {x.sourcesOfincomeID === "O" ? (
                        <>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.NolessWFTPsourcesOfincomeID"
                                checked={
                                  formik.values.document
                                    .NolessWFTPsourcesOfincomeID ===
                                  x.sourcesOfincomeID
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "document.NolessWFTPsourcesOfincomeID",
                                    x.sourcesOfincomeID
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                          <TextField
                            disabled={
                              formik.values.document
                                .NolessWFTPsourcesOfincomeID !== "O"
                            }
                            variant="outlined"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="document.NolessWFTPsourcesOfincomeOther"
                            value={
                              formik.values.document
                                .NolessWFTPsourcesOfincomeOther
                            }
                          />
                        </>
                      ) : null}
                    </>
                  ))}
                  <FormHelperText
                    error={isError(
                      "document.NolessWFTPsourcesOfincomeID",
                      formik
                    )}
                  >
                    {getErrorMessage(
                      "document.NolessWFTPsourcesOfincomeID",
                      formik
                    )}
                  </FormHelperText>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
        </>
      ) : null}

      {/* End Section 1 */}

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.IncomeMorethanWFTP"
                    checked={
                      formik.values.document.IncomeMorethanWFTP === "true"
                    }
                    onClick={() => {
                      formik.setFieldValue(
                        "document.IncomeMorethanWFTP",
                        formik.values.document.IncomeMorethanWFTP === "true"
                          ? "false"
                          : "true"
                      );
                      formik.setFieldValue(
                        "document.IncomeNolessWFTP",
                        "false"
                      );
                    }}
                  />
                }
                label={
                  <Typography style={{ fontWeight: "bold" }}>
                    {` Personal income >= 40,000 USD/year in the past 2 years`}
                  </Typography>
                }
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {formik.values.document.IncomeMorethanWFTP === "true" ? (
        <>
          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Year</InputLabel>
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Income (USD)</InputLabel>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>
                    Total current year income (as of the submission date)
                  </InputLabel>
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    label="Start"
                    format="DD-MM-YYYY"
                    views={["year", "month", "date"]}
                    name={`document.MorethanCurrentYearIncome`}
                    value={
                      get(
                        formik.values,
                        `document.MorethanCurrentYearIncome`,
                        null
                      ) || null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.MorethanCurrentYearIncome`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(
                      `document.MorethanCurrentYearIncome`,
                      formik
                    )}
                    helperText={getErrorMessage(
                      `document.MorethanCurrentYearIncome`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    label="End"
                    format="DD-MM-YYYY"
                    views={["year", "month", "date"]}
                    name={`document.MorethanCurrentYearIncomeEnd`}
                    value={
                      get(
                        formik.values,
                        `document.MorethanCurrentYearIncomeEnd`,
                        null
                      ) || null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.MorethanCurrentYearIncomeEnd`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(
                      `document.MorethanCurrentYearIncomeEnd`,
                      formik
                    )}
                    helperText={getErrorMessage(
                      `document.MorethanCurrentYearIncomeEnd`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>IncomeCurrentYearUSD</InputLabel>
                  <TextField
                    variant="outlined"
                    name="document.MorethanIncomeCurrentYearUSD"
                    value={formik.values.document.MorethanIncomeCurrentYearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Last year (YYYY)</InputLabel>
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="YYYY"
                    views={["year"]}
                    name={`document.MorethanLastYear`}
                    value={
                      get(formik.values, `document.MorethanLastYear`, null) ||
                      null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.MorethanLastYear`,
                        date.format("YYYY")
                      );
                    }}
                    error={isError(`document.MorethanLastYear`, formik)}
                    helperText={getErrorMessage(
                      `document.MorethanLastYear`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>IncomeLastYearUSD</InputLabel>
                  <TextField
                    variant="outlined"
                    name="document.MorethanIncomeLastYearUSD"
                    value={formik.values.document.MorethanIncomeLastYearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={4}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Last 2nd year (YYYY)</InputLabel>
                  <DatePicker
                    // style={{ width: 200 }}
                    className={classes.formControl}
                    inputVariant="outlined"
                    disableFuture={false}
                    openTo="year"
                    format="YYYY"
                    views={["year"]}
                    name={`document.MorethanLast2Year`}
                    value={
                      get(formik.values, `document.MorethanLast2Year`, null) ||
                      null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `document.MorethanLast2Year`,
                        date.format("YYYY")
                      );
                    }}
                    error={isError(`document.MorethanLast2Year`, formik)}
                    helperText={getErrorMessage(
                      `document.MorethanLast2Year`,
                      formik
                    )}
                    disabled={!canEdit}
                  />
                </div>
              </div>
            </StyledTableCell>

            <StyledTableCell colSpan={3}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>IncomeLast2YearUSD</InputLabel>
                  <TextField
                    variant="outlined"
                    name="document.MorethanIncomeLast2YearUSD"
                    value={formik.values.document.MorethanIncomeLast2YearUSD}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </StyledTableCell>
          </TableRow>

          <TableRow>
            <StyledTableCell colSpan={7}>
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <InputLabel>Sources of income</InputLabel>
                  <FormGroup row>
                    {sourceIncoms.map((x) => (
                      <>
                        {x.sourcesOfincomeID !== "O" ? (
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.MorethanWFTPsourcesOfincomeID
                            "
                                checked={
                                  formik.values.document
                                    .MorethanWFTPsourcesOfincomeID ===
                                  x.sourcesOfincomeID
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "document.MorethanWFTPsourcesOfincomeID",
                                    x.sourcesOfincomeID
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                        ) : null}
                      </>
                    ))}
                  </FormGroup>
                  {sourceIncoms.map((x) => (
                    <>
                      {x.sourcesOfincomeID === "O" ? (
                        <>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={!canEdit}
                                name="document.MorethanWFTPsourcesOfincomeID"
                                checked={
                                  formik.values.document
                                    .MorethanWFTPsourcesOfincomeID ===
                                  x.sourcesOfincomeID
                                }
                                onClick={() => {
                                  formik.setFieldValue(
                                    "document.MorethanWFTPsourcesOfincomeID",
                                    x.sourcesOfincomeID
                                  );
                                }}
                              />
                            }
                            label={x.sourcesOfincomeName}
                          />
                          <TextField
                            disabled={
                              formik.values.document
                                .MorethanWFTPsourcesOfincomeID !== "O"
                            }
                            variant="outlined"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="document.MorethanWFTPsourcesOfincomeOther"
                            value={
                              formik.values.document
                                .MorethanWFTPsourcesOfincomeOther
                            }
                          />
                        </>
                      ) : null}
                    </>
                  ))}
                  <FormHelperText
                    error={isError(
                      "document.MorethanWFTPsourcesOfincomeID",
                      formik
                    )}
                  >
                    {getErrorMessage(
                      "document.MorethanWFTPsourcesOfincomeID",
                      formik
                    )}
                  </FormHelperText>
                </div>
              </div>
            </StyledTableCell>
          </TableRow>
        </>
      ) : null}

      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ fontWeight: "bold", color: "#172B4D" }}>
                The applicant must have one of the followings investments in
                Thailand
              </InputLabel>
              <FormGroup>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="document.followinvestmentsID"
                      value="M"
                      checked={
                        formik.values.document.followinvestmentsID === "1"
                      }
                      onClick={() => {
                        formik.setFieldValue(
                          "document.followinvestmentsID",
                          "1"
                        );
                      }}
                    />
                  }
                  label="Obtaining a master's degree or above in science and technology"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="document.followinvestmentsID"
                      checked={
                        formik.values.document.followinvestmentsID === "2"
                      }
                      onClick={() => {
                        formik.setFieldValue(
                          "document.followinvestmentsID",
                          "2"
                        );
                      }}
                    />
                  }
                  label="Having an intellectual property"
                />
              </FormGroup>
            </div>
          </div>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Type of Intellectual Property</InputLabel>

              <FormGroup row>
                {typeOfIntellectualpropertyConfig.map((x) => (
                  <>
                    {x.typeOfIntellectualpropertyID !== "O" ? (
                      <FormControlLabel
                        control={
                          <StyleCheckbox
                            disabled={!canEdit}
                            name="document.typeOfIntellectualpropertyID
                            "
                            checked={
                              formik.values.document
                                .typeOfIntellectualpropertyID ===
                              x.typeOfIntellectualpropertyID
                            }
                            onClick={() => {
                              formik.setFieldValue(
                                "document.typeOfIntellectualpropertyID",
                                x.typeOfIntellectualpropertyID
                              );
                              formik.setFieldValue(
                                "document.typeOfIntellectualpropertyOther",
                                ""
                              );
                            }}
                          />
                        }
                        label={x.typeOfIntellectualpropertyName}
                      />
                    ) : null}
                  </>
                ))}
              </FormGroup>
              {typeOfIntellectualpropertyConfig.map((x) => (
                <>
                  {x.typeOfIntellectualpropertyID === "O" ? (
                    <>
                      <FormControlLabel
                        control={
                          <StyleCheckbox
                            disabled={!canEdit}
                            name="document.typeOfIntellectualpropertyID"
                            checked={
                              formik.values.document
                                .typeOfIntellectualpropertyID ===
                              x.typeOfIntellectualpropertyID
                            }
                            onClick={() => {
                              formik.setFieldValue(
                                "document.typeOfIntellectualpropertyID",
                                x.typeOfIntellectualpropertyID
                              );
                            }}
                          />
                        }
                        label={x.typeOfIntellectualpropertyName}
                      />
                      <TextField
                        disabled={
                          formik.values.document
                            .typeOfIntellectualpropertyID !== "O"
                        }
                        variant="outlined"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="document.typeOfIntellectualpropertyOther"
                        value={
                          formik.values.document.typeOfIntellectualpropertyOther
                        }
                      />
                    </>
                  ) : null}
                </>
              ))}
              <FormHelperText
                error={isError("document.typeOfIntellectualpropertyID", formik)}
              >
                {getErrorMessage(
                  "document.typeOfIntellectualpropertyID",
                  formik
                )}
              </FormHelperText>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Name of the invention / Product / Others</InputLabel>
              <TextField
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="document.NameInvention"
                value={formik.values.document.NameInvention}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Patent/Certificate number</InputLabel>
              <TextField
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="document.CertificateNumber"
                value={formik.values.document.CertificateNumber}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Country of registration </InputLabel>
              <TextField
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="document.CountryOfregistration"
                value={formik.values.document.CountryOfregistration}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Date of the registration (DD/MM/YY)</InputLabel>
              <DatePicker
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="YYYY"
                views={["year"]}
                name={`document.DateRegistration`}
                value={
                  get(formik.values, `document.DateRegistration`, null) || null
                }
                onChange={(date) => {
                  formik.setFieldValue(
                    `document.DateRegistration`,
                    date.format("YYYY")
                  );
                }}
                error={isError(`document.DateRegistration`, formik)}
                helperText={getErrorMessage(
                  `document.DateRegistration`,
                  formik
                )}
                disabled={!canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <FormControlLabel
                control={
                  <StyleCheckbox
                    disabled={!canEdit}
                    name="document.ObtainingSeriesA"
                    checked={formik.values.document.ObtainingSeriesA === "true"}
                    onClick={() => {
                      formik.setFieldValue(
                        "document.ObtainingSeriesA",
                        formik.values.document.ObtainingSeriesA === "true"
                          ? "false"
                          : "true"
                      );
                    }}
                  />
                }
                label="Obtaining series A funding no less than 1 million USD "
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Company/project name</InputLabel>
              <TextField
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="document.PersonalCompanyName"
                value={formik.values.document.PersonalCompanyName}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Address</InputLabel>
              <TextField
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="document.PersonalCompanyAddress"
                value={formik.values.document.PersonalCompanyAddress}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Business/products or services description</InputLabel>
              <TextField
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="document.PersonalProductServices"
                value={formik.values.document.PersonalProductServices}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Funding amount received (USD)</InputLabel>
              <TextField
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="document.PersonalFundingAmount"
                value={formik.values.document.PersonalFundingAmount}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
